<template>
  <div class="footer-root">

    <!-- ══ DOWNLOAD BANNER ══ -->
    <div v-if="!hideDownload" class="download-banner">
      <div class="db-noise"></div>
      <div class="container db-inner">
        <!-- Left: text -->
        <div class="db-text">
          <div class="db-tag">বিসিএস প্রস্তুতি অ্যাপ</div>
          <h2 class="db-title">স্মার্ট প্রস্তুতি শুরু করুন আজই</h2>
          <p class="db-sub">Download our mobile app, start learning from today</p>
          <div class="db-actions">
            <button class="db-play-btn" @click="trackAppDownload" aria-label="Google Play থেকে ডাউনলোড করুন">
              <img :src="require('@/assets/images/googlePlay.png')" alt="Get it on Google Play">
            </button>
            <a href="tel:+8801894442944" class="db-btn-outline">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" fill="currentColor"/>
              </svg>
              01894-442944
            </a>
          </div>
        </div>
        <!-- Right: phones -->
        <div class="db-phones">
          <img class="db-img-front" :src="require('@/assets/src.png')"  alt="BCS App">
          <img class="db-img-back"  :src="require('@/assets/src2.png')" alt="BCS App">
        </div>
      </div>
    </div>

    <!-- ══ MAIN FOOTER ══ -->
    <footer class="main-footer">
      <div class="mf-top-rule"></div>

      <div class="container mf-body">

        <!-- Col 1: Brand -->
        <div class="mf-col mf-brand">
          <img class="mf-logo" src="@/assets/images/bcslogo.png" alt="BCS Prostuti">
          <p class="mf-tagline">বিসিএস প্রস্তুতির স্মার্ট সঙ্গী — ৯ লাখ+ শিক্ষার্থীর বিশ্বাস</p>
          <div class="mf-contact-list">
            <a href="mailto:support@bcsprostuti.com" class="mf-contact-item">
              <span class="mf-contact-icon">✉</span>
              support@bcsprostuti.com
            </a>
            <a href="tel:+8801894442944" class="mf-contact-item">
              <span class="mf-contact-icon">✆</span>
              01894-442944
            </a>
            <div class="mf-contact-item mf-address">
              <span class="mf-contact-icon">⌖</span>
              <span>22-23 Station Road, Tejgaon,<br>Dhaka-1215</span>
            </div>
          </div>
        </div>

        <!-- Col 2: Links -->
        <div class="mf-col">
          <h4 class="mf-col-title">গুরুত্বপূর্ণ লিংক</h4>
          <ul class="mf-links">
            <li><a href="/about-us">About Us</a></li>
            <li><a href="/blogs">Blog</a></li>
            <li><a href="/faq">FAQ</a></li>
            <li><a href="/packages">Packages</a></li>
          </ul>
        </div>

        <!-- Col 3: Legal -->
        <div class="mf-col">
          <h4 class="mf-col-title">নীতিমালা</h4>
          <ul class="mf-links">
            <li><a href="https://bcsprostuti.com/privacy-policy.html" target="_blank">Privacy Policy</a></li>
            <li><a href="https://bcsprostuti.com/terms-condition.html" target="_blank">Terms & Conditions</a></li>
            <li><a href="https://bcsprostuti.com/refund-policy.html" target="_blank">Refund Policy</a></li>
          </ul>
        </div>

        <!-- Col 4: App + Social -->
        <div class="mf-col mf-col-app">
          <div class="mf-app-block">
            <h4 class="mf-col-title">অ্যাপ ডাউনলোড</h4>
            <div class="mf-play-btn" @click="trackAppDownload">
              <img :src="require('@/assets/images/googlePlay.png')" alt="Get it on Google Play">
            </div>
          </div>
          <div class="mf-social-block">
            <h4 class="mf-col-title">আমাদের অনুসরণ করুন</h4>
            <div class="mf-socials">
              <!-- Facebook Page -->
              <a href="https://www.facebook.com/BCS-Prostuti-500734590359140/" target="_blank" class="mf-social-link" title="Facebook Page">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.47H7.078V12h3.047V9.356c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.47h-2.796v8.385C19.612 22.954 24 17.99 24 12z" fill="currentColor"/>
                </svg>
              </a>
              <!-- Facebook Group -->
              <a href="https://www.facebook.com/groups/bcsprostuti" target="_blank" class="mf-social-link" title="Facebook Group">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor"/>
                </svg>
              </a>
              <!-- Messenger -->
              <a href="https://m.me/bcsprostutiApp" target="_blank" class="mf-social-link" title="Messenger">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0C5.373 0 0 4.975 0 11.111c0 3.497 1.745 6.616 4.472 8.652V24l4.086-2.242c1.09.301 2.246.464 3.442.464 6.627 0 12-4.974 12-11.11C24 4.975 18.627 0 12 0zm1.194 14.963l-3.055-3.26-5.963 3.26L10.732 8.1l3.131 3.26L19.752 8.1l-6.558 6.863z" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

      </div>

      <!-- SSLCommerz -->
      <div class="container mf-ssl">
        <img src="@/assets/images/sslcommerze.png" alt="SSLCommerz">
      </div>

      <!-- Bottom bar -->
      <div class="mf-bottom">
        <div class="container mf-bottom-inner">
          <span class="mf-copy">© {{ currentYear }} BCS Prostuti. All rights reserved.</span>
          <span class="mf-made">Developed by <a href="https://codeminersit.com" target="_blank">Codeminers IT Limited</a></span>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import { computed } from "vue";
import { fbPixel, gaEvent } from "@/config/pixels";

export default {
  props: {
    hideDownload: { type: Boolean, default: false }
  },
  setup() {
    const currentYear = computed(() => new Date().getFullYear());

    const trackAppDownload = () => {
      fbPixel('Lead', {
        content_name: 'Footer App Download Link',
        content_category: 'BCS App'
      });
      gaEvent('app_download_click', {
        event_category: 'engagement',
        event_label: 'welcome_footer_download'
      });
      window.open('https://play.google.com/store/apps/details?id=com.bcsprostuti.tanim.bcsprostuti', '_blank');
    };

    return { currentYear, trackAppDownload };
  },
};
</script>

<style scoped>
/* ══ ROOT ══ */
.footer-root { font-family: system-ui, -apple-system, sans-serif; }

/* ══ DOWNLOAD BANNER ══ */
.download-banner {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #191B47 0%, #0f1130 60%, #1a0828 100%);
}
.db-noise {
  position: absolute; inset: 0; pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
}

/* two-column: left text | right phones */
.db-inner {
  position: relative; z-index: 1;
  display: flex; align-items: center;
  gap: 48px; padding: 60px 0;
}

/* left text */
.db-text { flex: 1; }
.db-tag {
  display: inline-block; font-size: 0.72rem; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: #38B6FF; background: rgba(0,149,255,0.15);
  border: 1px solid rgba(0,149,255,0.35);
  padding: 4px 14px; border-radius: 999px; margin-bottom: 16px;
}
.db-title {
  font-family: 'Noto Serif Bengali', serif;
  font-size: clamp(1.8rem, 3.5vw, 2.8rem);
  font-weight: 900; color: #fff; line-height: 1.25; margin-bottom: 12px;
}
.db-sub { font-size: 0.95rem; color: #94a3b8; margin-bottom: 32px; }
.db-actions { display: flex; gap: 12px; flex-wrap: wrap; align-items: center; justify-content: center; }
.db-play-btn {
  display: inline-flex; align-items: center;
  padding: 0; border: none; background: transparent;
  border-radius: 10px; cursor: pointer;
  box-shadow: 0 6px 16px rgba(0,0,0,0.3);
  transition: transform 0.2s, box-shadow 0.2s;
}
.db-play-btn img { display: block; height: 52px; width: auto; border-radius: 10px; }
.db-play-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(0,0,0,0.4); }
.db-btn-outline {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  height: 52px;
  border: 1.5px solid rgba(255,255,255,0.3); color: #fff;
  font-weight: 600; font-size: 0.9rem;
  border-radius: 10px; padding: 0 22px;
  text-decoration: none; transition: all 0.2s;
}
.db-btn-outline:hover { border-color: #fff; background: rgba(255,255,255,0.08); }

/* right phones */
.db-phones {
  flex-shrink: 0; position: relative;
  width: 300px; height: 380px;
}
.db-img-front {
  width: 165px; height: 340px; object-fit: cover;
  border-radius: 22px; position: absolute;
  left: 0; bottom: 0; z-index: 2;
  box-shadow: 0 20px 48px rgba(0,0,0,0.5);
}
.db-img-back {
  width: 150px; height: 300px; object-fit: cover;
  border-radius: 20px; position: absolute;
  right: 0; bottom: 20px; z-index: 1;
  box-shadow: 0 16px 40px rgba(0,0,0,0.35);
  opacity: 0.85;
}

@media(max-width: 768px) {
  .db-phones { display: none; }
  .db-inner { padding: 44px 0; }
}

/* ══ MAIN FOOTER ══ */
.main-footer {
  background: #12142e;
  margin-top: 0;
}
.mf-top-rule {
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #38B6FF 30%, #38B6FF 70%, transparent 100%);
}
.mf-body {
  display: grid;
  grid-template-columns: 1.8fr 1fr 1fr 1.2fr;
  gap: 40px; padding-top: 52px; padding-bottom: 44px;
  align-items: start;
}
@media(max-width: 992px) { .mf-body { grid-template-columns: 1fr 1fr; gap: 32px; } }
@media(max-width: 560px)  { .mf-body { grid-template-columns: 1fr; gap: 24px; padding-top: 32px; } }

/* Columns — force left alignment (overrides global #app text-align:center) */
.mf-col { text-align: left; }

/* Brand col */
.mf-logo { width: 72px; height: 72px; object-fit: contain; margin-bottom: 16px; }
.mf-tagline {
  font-size: 0.83rem; color: #94a3b8; line-height: 1.6;
  margin-bottom: 24px; max-width: 260px;
}
.mf-contact-list { display: flex; flex-direction: column; gap: 12px; }
.mf-contact-item {
  display: flex; align-items: flex-start; gap: 10px;
  font-size: 0.82rem; color: #94a3b8; text-decoration: none;
  transition: color 0.18s;
}
.mf-contact-item:hover { color: #e2e8f0; }
.mf-contact-icon {
  width: 22px; height: 22px; background: rgba(0,149,255,0.12);
  border: 1px solid rgba(0,149,255,0.25); border-radius: 6px;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 0.7rem; color: #38B6FF; flex-shrink: 0; margin-top: 1px;
}
.mf-address { align-items: flex-start; cursor: default; }

/* Columns */
.mf-col-title {
  font-size: 0.7rem; font-weight: 800; letter-spacing: 0.1em;
  text-transform: uppercase; color: #38B6FF; margin-bottom: 14px;
  background: transparent !important; padding: 0; border: none;
}
.mf-links { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 11px; }
.mf-links li a {
  font-size: 0.85rem; color: #94a3b8; text-decoration: none;
  transition: color 0.18s; display: inline-flex; align-items: center; gap: 6px;
}
.mf-links li a::before {
  content: ''; width: 0; height: 1px;
  background: #38B6FF; transition: width 0.2s; display: inline-block;
}
.mf-links li a:hover { color: #f1f5f9; }
.mf-links li a:hover::before { width: 12px; }

/* Col 4 structure */
.mf-col-app { display: flex; flex-direction: column; gap: 28px; }
.mf-app-block { display: flex; flex-direction: column; align-items: flex-start; }
.mf-social-block { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; }

/* Play button */
.mf-play-btn {
  cursor: pointer; display: inline-block;
  border-radius: 10px; overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  margin-top: 4px;
}
.mf-play-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,0.4); }
.mf-play-btn img { display: block; height: 44px; width: auto; }

/* Socials */
.mf-socials {
  display: flex; flex-direction: row;
  gap: 8px; align-items: center;
}
.mf-social-link {
  width: 36px; height: 36px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  color: #64748b; border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.05);
  transition: all 0.2s; text-decoration: none;
  flex-shrink: 0;
}
.mf-social-link svg { display: block; }
.mf-social-link:hover {
  color: #fff; background: #38B6FF;
  border-color: #38B6FF; transform: translateY(-2px);
}

/* SSLCommerz */
.mf-ssl {
  padding-bottom: 28px;
  border-top: 1px solid rgba(255,255,255,0.06);
  padding-top: 24px;
}
.mf-ssl img { height: 36px; width: auto; opacity: 0.7; filter: brightness(1.2); }

/* Bottom bar */
.mf-bottom {
  border-top: 1px solid rgba(255,255,255,0.06);
  background: #0d0f26; padding: 16px 0;
}
.mf-bottom-inner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 8px;
}
.mf-copy { font-size: 0.78rem; color: #475569; }
.mf-made { font-size: 0.78rem; color: #475569; }
.mf-made a { color: #64748b; text-decoration: none; transition: color 0.18s; }
.mf-made a:hover { color: #38B6FF; }
</style>
